import { getEl, getTextArea } from '../../core/dom.js';
import { getTg } from '../../core/telegram.js';

export const aiChatMessagesEl = getEl('ai-chat-messages');
export const aiChatInputEl = getTextArea('ai-chat-input');
export const aiChatSendBtn = getEl<HTMLButtonElement>('ai-chat-send-btn');

export function getAiChatInitData(): string {
  const tgAi = getTg();
  return tgAi && tgAi.initData ? String(tgAi.initData) : '';
}
